import { render } from "./FoodcycleProviders.vue?vue&type=template&id=bd57662c&scoped=true"
import script from "./FoodcycleProviders.vue?vue&type=script&lang=js"
export * from "./FoodcycleProviders.vue?vue&type=script&lang=js"

import "./FoodcycleProviders.vue?vue&type=style&index=0&id=bd57662c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd57662c"]])

export default __exports__